import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "recensement-container" }
const _hoisted_2 = {
  key: 0,
  class: "scanner-section"
}
const _hoisted_3 = { class: "scanner-container" }
const _hoisted_4 = {
  class: "scanner-box",
  ref: "scannerBox"
}
const _hoisted_5 = {
  ref: "videoElement",
  class: "scanner-video"
}
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-md-12 col-12 col-sm-12" }
const _hoisted_8 = { class: "manual-input-section" }
const _hoisted_9 = { class: "manual-input" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-md-12 col-12 col-sm-12" }
const _hoisted_12 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_13 = { class: "col-md-12 col-12 col-sm-12" }
const _hoisted_14 = { class: "form-group mb-15 mb-sm-20 mb-md-25 d-flex justify-content-center" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = {
  key: 0,
  class: "fas fa-search"
}
const _hoisted_17 = {
  key: 1,
  class: "spinner-border spinner-border-sm",
  role: "status"
}
const _hoisted_18 = {
  key: 1,
  class: "loading-overlay"
}
const _hoisted_19 = {
  key: 2,
  class: "results-section"
}
const _hoisted_20 = { class: "modal-header" }
const _hoisted_21 = { class: "modal-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!
  const _component_IdentityCard = _resolveComponent("IdentityCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[17] || (_cache[17] = _createElementVNode("div", { class: "header-section" }, [
      _createElementVNode("h1", { class: "page-title" }, [
        _createElementVNode("i", { class: "fas fa-qrcode" }),
        _createTextVNode(" Recensement des Usagers - Marché de Dantokpa ")
      ]),
      _createElementVNode("p", { class: "page-subtitle" }, "Scannez le code QR pour récupérer les informations de l'usager")
    ], -1)),
    (!_ctx.showResults)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("video", _hoisted_5, null, 512),
              _cache[7] || (_cache[7] = _createElementVNode("div", { class: "scanner-overlay" }, [
                _createElementVNode("div", { class: "scanner-frame" }),
                _createElementVNode("div", { class: "scanner-text" }, [
                  _createElementVNode("i", { class: "fas fa-qrcode" }),
                  _createElementVNode("p", null, "Positionnez le code QR dans le cadre")
                ])
              ], -1))
            ], 512),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _cache[10] || (_cache[10] = _createElementVNode("div", { class: "divider" }, [
                    _createElementVNode("span", null, "OU")
                  ], -1)),
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_Form, {
                      ref: "searchForm",
                      onSubmit: _ctx.searchByManualCode,
                      "validation-schema": _ctx.searchSchema
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, [
                              _cache[8] || (_cache[8] = _createElementVNode("label", {
                                for: "manualCode",
                                class: "form-label"
                              }, "Saisie manuelle :", -1)),
                              _createVNode(_component_Field, {
                                type: "text",
                                class: "form-control shadow-none fs-md-15 text-black",
                                name: "npi",
                                placeholder: "Entrez le NPI, matricule ou code emplacement",
                                modelValue: _ctx.npi,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.npi) = $event))
                              }, null, 8, ["modelValue"]),
                              _createVNode(_component_ErrorMessage, {
                                name: "npi",
                                class: "text-danger mt-2"
                              })
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("div", _hoisted_14, [
                              _createElementVNode("button", {
                                type: "submit",
                                class: "btn btn-primary shadow-none fs-md-15 text-black",
                                disabled: _ctx.isSearching
                              }, [
                                _cache[9] || (_cache[9] = _createTextVNode(" Vérifier ", -1)),
                                (!_ctx.isSearching)
                                  ? (_openBlock(), _createElementBlock("i", _hoisted_16))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_17))
                              ], 8, _hoisted_15)
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }, 8, ["onSubmit", "validation-schema"])
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [...(_cache[11] || (_cache[11] = [
          _createElementVNode("div", { class: "loading-container" }, [
            _createElementVNode("div", { class: "custom-spinner" }, [
              _createElementVNode("div", { class: "spinner-circle" })
            ]),
            _createElementVNode("p", { class: "loading-text" }, "Vérification en cours...")
          ], -1)
        ]))]))
      : _createCommentVNode("", true),
    (_ctx.showResults && _ctx.usagerInfo)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _createElementVNode("div", {
            class: "modal-overlay",
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.closeResults && _ctx.closeResults(...args)))
          }, [
            _createElementVNode("div", {
              class: "modal-content",
              onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
            }, [
              _createElementVNode("div", _hoisted_20, [
                _cache[13] || (_cache[13] = _createElementVNode("h3", null, "Informations de l'Usager", -1)),
                _createElementVNode("button", {
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeResults && _ctx.closeResults(...args))),
                  class: "close-btn"
                }, [...(_cache[12] || (_cache[12] = [
                  _createElementVNode("i", { class: "fas fa-times" }, null, -1)
                ]))])
              ]),
              _createVNode(_component_IdentityCard, { usagerInfo: _ctx.usagerInfo }, null, 8, ["usagerInfo"]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("button", {
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closeResults && _ctx.closeResults(...args))),
                  class: "btn btn-secondary"
                }, [...(_cache[14] || (_cache[14] = [
                  _createElementVNode("i", { class: "fas fa-times" }, null, -1),
                  _createTextVNode(" Fermer ", -1)
                ]))]),
                _createElementVNode("button", {
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.startNewScan && _ctx.startNewScan(...args))),
                  class: "btn btn-primary"
                }, [...(_cache[15] || (_cache[15] = [
                  _createElementVNode("i", { class: "fas fa-qrcode" }, null, -1),
                  _createTextVNode(" Nouveau Scan ", -1)
                ]))]),
                _createElementVNode("button", {
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.goToRecensementForm && _ctx.goToRecensementForm(...args))),
                  class: "btn btn-success"
                }, [...(_cache[16] || (_cache[16] = [
                  _createElementVNode("i", { class: "fas fa-user-edit" }, null, -1),
                  _createTextVNode(" Recenser cet usager ", -1)
                ]))])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}